export default __webpack_public_path__ + "static/media/US EPA.771e5b25.png";